import { getCookie } from "../services/config/storage";

const isAuthenticated = () => {
  const token = getCookie("_access_token_" + process.env.REACT_APP_ENV);
  return token ? true : false;
};
export default isAuthenticated;
